

<template>
  <header class="simple-header">
    <i class="nbicon nbfanhui" @click="goBack"></i>
    <div class="simple-header-name">{{ name }}</div>
  </header>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    back: {
      type: String,
      default: ''
    }
  },
  methods: {
    goBack() {
      if (!this.back) {
        this.$router.go(-1)
      } else {
        this.$router.push({ path: this.back })
      }
      this.$emit('callback')
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../style/mixin';
  .simple-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .fj();
    .wh(100%, 50px);
    line-height: 50px;
    padding: 0 10px;
    .boxSizing();
    color: #252525;
    background: #fff;
    justify-content: flex-start;
    border-bottom: 1px solid #dcdcdc;
    .simple-header-name {
      font-size: 16px;
      padding-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SimpleHeader.vue